import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Trophy, X } from 'lucide-react';
import confetti from 'canvas-confetti';
import './QuestionSuccessModal.css';

const QuestionSuccessModal = ({ open, onClose, score, questionScore, questionEvaluation, onNext }) => {
  const { t } = useTranslation();
  
  // Use question_score if provided, otherwise fall back to score
  const displayScore = questionScore !== null && questionScore !== undefined ? questionScore : score;

  useEffect(() => {
    if (open) {
      confetti({
        particleCount: 150,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000
      });
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="questionSuccessModal__overlay" onClick={onClose}>
      <div className="questionSuccessModal__content" onClick={e => e.stopPropagation()}>
        <button className="questionSuccessModal__close" onClick={onClose}>
          <X size={20} />
        </button>
        
        <div className="questionSuccessModal__header">
          <Trophy size={60} className="questionSuccessModal__icon" />
          <h2 className="questionSuccessModal__title">
            {t('recordingQuestion.success.title')}
          </h2>
        </div>

        <div className="questionSuccessModal__body">
          <div className="questionSuccessModal__score">
            {displayScore !== null && displayScore !== undefined ? displayScore.toFixed(1) : 'N/A'}/10
          </div>
          <div className="questionSuccessModal__scoreLabel">
            {questionScore !== null && questionScore !== undefined 
              ? t('recordingQuestion.success.questionScore') 
              : t('recordingQuestion.success.score')}
          </div>
          {questionEvaluation?.feedback && (
            <p className="questionSuccessModal__feedback">
              {questionEvaluation.feedback}
            </p>
          )}
          <p className="questionSuccessModal__message">
            {t('recordingQuestion.success.message')}
          </p>
        </div>

        <div className="questionSuccessModal__actions">
          <button 
            className="questionSuccessModal__cta"
            onClick={onNext}
          >
            {t('recordingQuestion.success.cta')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionSuccessModal;
